import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import {createBrowserRouter, RouterProvider} from 'react-router-dom';
import Home from './pages/Home/Home';
import Services from './pages/Services/Services';
import Contact from './pages/Contact/Contact';
import {Provider} from 'react-redux';
import store from './redux';
import ProductDetailsPage from './pages/ProductDetailsPage/ProductDetailsPage';
import ProductsListPage from './pages/ProductsListPage/ProductsListPage';
import Sandbox from './pages/Sandbox/Sandbox';
import Checkout from './pages/Checkout/Checkout';
import ProductsCategoryPage from './pages/ProductsCategoryPage/ProductsCategoryPage';
import ServiceDetails from './pages/Services/service-details/ServiceDetails';
import { ROUTES } from './constants/routes';

const router = createBrowserRouter([
  {
    path: ROUTES.HOME,
    element: <App/>,
    children: [
      {
        path: ROUTES.HOME,
        element: <Home/>
      },
      {
        path: ROUTES.SERVICES,
        element: <Services/>
      },
      {
        path: ROUTES.SERVICE_DETAILS,
        element: <ServiceDetails/>
      },
      {
        path: ROUTES.CONTACT,
        element: <Contact/>
      },
      {
        path: ROUTES.CONTACT_ID,
        element: <Contact/>
      },
      {
        path: ROUTES.CONTACT_ID_PID,
        element: <Contact/>
      },
      {
        path: ROUTES.PRODUCTS,
        element: <ProductsCategoryPage/>
      },
      {
        path: ROUTES.PRODUCTS_CATEGORY,
        element: <ProductsListPage/>
      },
      {
        path: ROUTES.PRODUCTS_DETAILS,
        element: <ProductDetailsPage/>
      },
      {
        path: ROUTES.SANDBOX,
        element: <Sandbox/>
      },
      {
        path: ROUTES.CHECKOUT,
        element: <Checkout/>
      }
    ]
  }
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
      <Provider store={store}>
        <RouterProvider router={router}/>
      </Provider>
    </React.StrictMode>
);
